import { z } from 'zod';
import { OrderStatus } from '@/features/orders/types/orders-dto';
import { t } from 'i18next';

export const OrdersPageFilterFormSchema = z.object({  
  startDate: z
    .date({ message: t('elements.form.startDate.error') })
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  authorId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  apartmentId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  serviceId: z
    .array(z.object({
      id: z.string(),
      name: z.string().optional()
    }))
    .optional(),
  amountRange: z
    .string()
    .nullable()
    .optional(),
  orderStatus: z
    .nativeEnum(OrderStatus)
    .nullable()
    .optional(),
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);